import Keycloak from 'keycloak-js';
import { getEnvVar } from '../config';

const keycloak = new Keycloak({
  url: getEnvVar('VITE_KEYCLOAK_URL', '<keycloak-service-url>'),
  realm: getEnvVar('VITE_KEYCLOAK_REALM', 'rlca'),
  clientId: getEnvVar('VITE_KEYCLOAK_CLIENT_ID', 'rlca-frontend')
});

// Expose keycloak instance for MFE remotes (rlca-module, etc.)
(window as any).__KEYCLOAK__ = keycloak;

export default keycloak;
